import PropTypes from 'prop-types'

const nodeType = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  name: PropTypes.string.isRequired,
  parentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isCurationEnabled: PropTypes.bool.isRequired,
  level: PropTypes.number.isRequired,
  idPath: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ),
  namePath: PropTypes.arrayOf(PropTypes.string),
  key: PropTypes.string,
  path: PropTypes.string,
  keyPath: PropTypes.arrayOf(PropTypes.string),
  parentPath: PropTypes.string,
}

export const nodePropType = PropTypes.shape(nodeType)

export const ingredientNodePropType = PropTypes.shape({
  ...nodeType,
  isWholeFood: PropTypes.bool,
  isVague: PropTypes.bool,
  definiteComponentIngredients: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ),
})

ingredientNodePropType.children = PropTypes.arrayOf(
  PropTypes.shape(ingredientNodePropType),
)
